export default __webpack_public_path__ + "static/media/facebook.f5a8c6ea.svg";